"use client";

import React, { useEffect } from "react";
import { setData } from "rivals/shared/utils/qa";

function SendToNews({ videoId }: { videoId: string }): React.JSX.Element {
  useEffect(() => {
    const srcUrl = `https://embed.sendtonews.com/player2/embedcode.php?SC=${videoId}&autoplay=on&sound=off`;

    const s = document.createElement("script");
    s.setAttribute("src", srcUrl);
    s.setAttribute("type", "text/javascript");
    s.setAttribute("data-embed", "s2nScript");
    document.getElementById(`s2n-player-container-${videoId}`)?.appendChild(s);

    // Removes the embed script on unmount
    return s.remove;
  }, [videoId]);

  return (
    <div id={`s2n-player-container-${videoId}`}>
      <div
        className={`s2nPlayer-${videoId}`}
        data-type="float"
        {...setData(`sendtonews-embed`, videoId)}
      />
    </div>
  );
}

export default SendToNews;
